const styles = () => ({
  errorAlert: { maxWidth: '600px', alignSelf: 'center' },
  circularProgressContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
});

export default styles;
